import { emailOTPClient } from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"
import { getBearerToken, IS_DESKTOP, setBearerToken } from "./desktopAuth"

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL,
  plugins: [emailOTPClient()],
  // On desktop, carry the session as a bearer token instead of a (blocked)
  // third-party cookie. See desktopAuth.ts.
  fetchOptions: IS_DESKTOP
    ? {
        auth: {
          type: "Bearer",
          token: () => getBearerToken() ?? "",
        },
        onSuccess: (ctx) => {
          const token = ctx.response.headers.get("set-auth-token")
          if (token) {
            setBearerToken(token)
          }
        },
      }
    : {},
})
